<template>
  <div id="login-modal">
    <el-dialog
      :title="$t('firstLogin.modalTitle')"
      :show-close="false"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :width="dialogWidth"
      center
    >
      <h2 class="login-modal-title">{{ $t('firstLogin.headerModal') }}</h2>
      <el-form :label-width="formLabelWidth" :label-position="labelPosition">
        <el-form-item :label="$t('firstLogin.officeTitle')">
          <office-dropdown
            :disabled="!user.isWizeliner"
            :selected="user.office"
            @change="setUserOffice"
          />
        </el-form-item>
        <el-form-item :label="$t('firstLogin.menuTitle')">
          <checkbox-group :display-description="true" @checked="updatedDiets" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <h2 class="login-modal-title">{{ $t('firstLogin.modalFooter') }}</h2>
        <router-link to="/menu">
          <el-button
            id="redirect-menu-button"
            :disabled="dietsIsEmpty"
            type="primary"
            @click="setFirstTimeLogIn"
          >
            {{ $t('firstLogin.saveButton') }}
          </el-button>
        </router-link>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OfficeDropdown from '@/components/OfficeDropdown';
import CheckboxGroup from '@/components/CheckboxGroup';
import { mapGetters, mapActions } from 'vuex';

const MAX_WIDTH = 1315; // beyond this width the modal overflows
export default {
  name: 'FirstLoginModal',
  props: {
    initialVisibility: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CheckboxGroup,
    OfficeDropdown,
  },
  data() {
    return {
      dialogFormVisible: this.initialVisibility,
      formLabelWidth: '320px',
      selectedDiets: [],
      pageWidth: window.innerWidth,
      windowSmallerThanMaxWidth: window.innerWidth < MAX_WIDTH,
    };
  },
  computed: {
    ...mapGetters('user', { user: 'getUser' }),
    dietsIsEmpty() {
      return this.selectedDiets.length === 0;
    },
    dialogWidth() {
      if (this.windowSmallerThanMaxWidth) {
        return '95%';
      }
      return '50%';
    },
    labelPosition() {
      if (this.windowSmallerThanMaxWidth) {
        return 'top';
      }
      return 'left';
    },
  },
  created() {
    window.addEventListener('resize', this.updatePageWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.updatePageWidth);
  },
  methods: {
    ...mapActions('user', {
      updateFirstLogIn: 'updateFirstLogIn',
      updateUsersOffice: 'updateUsersOffice',
    }),
    updatePageWidth() {
      this.windowSmallerThanMaxWidth = window.innerWidth < MAX_WIDTH;
    },
    updatedDiets(val) {
      this.selectedDiets = val;
    },
    setFirstTimeLogIn() {
      this.updateFirstLogIn(false);
      this.dialogFormVisible = false;
    },
    setUserOffice(officeId) {
      this.updateUsersOffice(officeId);
    },
  },
};
</script>
<style scoped lang="scss">
@import '../scss/variables';
.el-button {
  background-color: $first-login-modal-button-background;
  border-color: $first-login-modal-button-background;
  color: $first-login-modal-button-color;
  &.is-disabled {
    background-color: $disabled-button-background;
    border-color: $disabled-button-background;
    color: $disabled-button-color;
  }
}
.el-dialog {
  width: 55%;
  &__body {
    padding: 30px;
  }
  &__title {
    font-size: $title-font-size;
  }
  &__wrapper {
    position: fixed;
    margin: 0;
  }
}
.login-modal-title {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/FirstLoginModal.vue